<template>
  <a-modal
    :title="null"
    :width="560"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-tabs default-active-key="2">
      <!-- <a-tab-pane key="1" tab="验证码登录">
        <div class="pl-60 pr-60 pt-20">
          <a-form-model :model="form1">
            <a-form-model-item>
              <a-input v-model="form1.phone" placeholder="手机号码">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form1.code" type="验证码" placeholder="验证码">
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                <CountDown slot="suffix" :count="60" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                class="w-100p"
                type="primary"
                html-type="submit"
                :disabled="form1.phone === '' || form1.code === ''"
              >
                登录
              </a-button>
            </a-form-model-item>
          </a-form-model>
          <div class="t-right">没有账号?<span class="pointer f-c-blue" @click="toRegister">立即注册</span></div>
        </div>
      </a-tab-pane> -->
      <a-tab-pane key="2" tab="密码登录" force-render>
        <div class="flex a-center">
          <div class=" pl-40 pt-20">
            <a-form-model ref="form2" :model="form2" :rules="loginRules2">
              <a-form-model-item prop="username">
                <a-input v-model="form2.userName" placeholder="用户名或者手机号" @keyup.enter="postForm2">
                  <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input-password v-model="form2.userPassword" placeholder="密码" @keyup.enter="postForm2">
                  <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item>
                <a-button
                  class="w-100p"
                  type="primary"
                  :loading="form2Loading"
                  @click="postForm2"
                >
                  登录
                </a-button>
              </a-form-model-item>
            </a-form-model>
            <div class="t-right"><span class="pointer f-c-blue" @click="toResetPasswrod">忘记密码</span></div>
          </div>
          <div class="reg-h-line" />
          <div>
            <img class="w-114" src="@/assets/home/barcode@2x.png" alt="">
            <div class="t-center fs-12">
              微信扫码进入手机版<br>
              手机版寄件更便捷
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import CountDown from '../CountDown'
import { getToken, setToken } from '@framework/utils/auth' // get token from cookie
export default {
  components: {
    CountDown
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码最少需要6位'))
      } else {
        callback()
      }
    }
    return {
      loginRules2: {
        userName: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        userPassword: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      visible: false,
      confirmLoading: false,
      form1: {
        phone: '',
        code: ''
      },
      form2: {
        userName: '',
        userPassword: ''
      },
      form2Loading: false,
      jump: ''
    }
  },
  methods: {
    toRegister() {
      this.close()
      this.$register.show()
    },
    toResetPasswrod() {
      this.close()
      this.$resetpwd.show()
    },
    close() {
      this.jump = ''
      this.visible = false
    },
    show(path) {
      this.jump = path
      this.visible = true
    },

    postForm2() {
      this.$refs.form2.validate(async v => {
        if (v) {
          this.form2Loading = true
          try {
            // const res = await this.$http(this.$api.login, this.form2)
            await this.$store.dispatch('user/login', this.form2)
            // setToken(res.token)
            // localStorage.setItem('role', res.role)
            if (this.jump) {
              window.location.href = this.jump
              window.location.reload()
            } else {
              window.location.reload()
            }
            this.form2Loading = false
            this.close()
          } catch (error) {
            this.form2Loading = false
          }
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
 .reg-h-line{
    height: 144px;
    width: 1px;
    background: rgba(217, 217, 217, 1);
    margin-left: 40px;
    margin-right: 40px;

  }
</style>
